// extracted by mini-css-extract-plugin
module.exports = {"homePage":"home-module--homePage--3LNkm","homePageFade":"home-module--homePageFade--2KJP3","fadeInPage":"home-module--fadeInPage--LPltM","cardsRow":"home-module--cardsRow--2L4nA"};